// extracted by mini-css-extract-plugin
export default {"root":"JIqeC_JIqeC","load":"_lnPB__lnPB","actions":"BFSWu_BFSWu","icon":"uppl6_uppl6","pages":"kBWLj_kBWLj","page":"D0Ilt_D0Ilt"};